import React from "react";

/**
 * Monte Sol — Logo Component
 * Agora utiliza a imagem real enviada para a pasta public.
 */

export const LogoMark = ({ size = 70, className = "" }) => {
  return (
    <img 
      src="/Logo (Fundo Branco).png" 
      alt="Monte Sol Icon" 
      width={size}
      height="auto"
      className={`shrink-0 ${className}`}
      style={{ display: 'block' }}
    />
  );
};

/**
 * Logo Lockup - Se a tua imagem já tiver o texto "Monte Sol", 
 * usamos apenas a LogoMark. Se for apenas o ícone, este componente 
 * mantém o texto elegante ao lado.
 */
export const LogoLockup = ({ variant = "dark", className = "" }) => {
  // Nota: Se o teu ficheiro .png JÁ incluir o texto "Monte Sol",
  // podes simplesmente retornar <LogoMark size={150} /> aqui.
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark size={70} />
      {/* Mantemos o texto programmaticamente caso a tua imagem seja 
         apenas o símbolo do sol/montanha. Se a imagem já tiver tudo,
         podes apagar a <div flex-col> abaixo.
      */}
      <div className="flex flex-col leading-none">
        <span className={`font-serif text-xl md:text-2xl tracking-tight font-medium ${variant === "light" ? "text-[#FDFBF7]" : "text-[#003366]"}`}>
          Monte Sol
        </span>
        <span className={`text-[9px] md:text-[10px] tracking-[0.3em] uppercase font-semibold mt-1 ${variant === "light" ? "text-[#D4AF37]" : "text-[#708090]"}`}>
          Stone Steak House
        </span>
      </div>
    </div>
  );
};

export default LogoLockup;
